import React, { useEffect } from "react";
import { ACUITY_URL, GHL_CALENDAR_URL, OFFER } from "../mock";
import { trackPixel } from "../lib/pixel";

// Direct-booking calendar: embeds the GoHighLevel (or Acuity) scheduler inline (no quiz gate).
export const InlineScheduler = () => {
  useEffect(() => {
    trackPixel("Schedule", { content_name: OFFER.name });
    if (GHL_CALENDAR_URL) {
      // GoHighLevel embed auto-resizes the iframe via this helper script
      if (!document.getElementById("ghl-form-embed-js")) {
        const s = document.createElement("script");
        s.id = "ghl-form-embed-js";
        s.src = "https://link.msgsndr.com/js/form_embed.js";
        s.async = true;
        document.body.appendChild(s);
      }
    } else if (ACUITY_URL && !document.getElementById("acuity-embed-js")) {
      const s = document.createElement("script");
      s.id = "acuity-embed-js";
      s.src = "https://embed.acuityscheduling.com/js/embed.js";
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  if (!GHL_CALENDAR_URL && !ACUITY_URL) return null;

  return (
    <div
      id="quiz-form"
      data-testid="inline-scheduler"
      className="overflow-hidden rounded-3xl bg-white p-2 shadow-[0_30px_80px_-30px_rgba(35,35,32,0.35)] ring-1 ring-brand-cream md:p-3"
    >
      {GHL_CALENDAR_URL ? (
        <iframe
          title="Book your appointment"
          src={GHL_CALENDAR_URL}
          id="ghl-booking-iframe"
          allow="payment"
          scrolling="no"
          className="w-full"
          style={{ minHeight: "700px", border: 0, overflow: "hidden", display: "block" }}
        />
      ) : (
        <iframe
          title="Book your appointment"
          src={ACUITY_URL}
          className="w-full"
          style={{ minHeight: "640px", border: 0, display: "block" }}
          width="100%"
          height="800"
        />
      )}
    </div>
  );
};
